var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"empty-state",attrs:{"elevation":"0","color":"transparent"}},[_c('v-img',{staticClass:"empty-state__illustration",attrs:{"contain":"","aspect-ratio":"1","src":require('../assets/illustrations/' + _vm.illustration),"width":_vm.width,"height":_vm.height}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }